export default "__VITE_ASSET__CxXlCxZj__"